import {createContext} from 'react';

const OpenReplayContext = createContext([]);

export default OpenReplayContext;
